import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {PlannerApi, Schedule, ScheduleDetail} from '@api/planner';

@Injectable({providedIn: 'root'})
export class ScheduleEndpoint {

  constructor(private api: PlannerApi) {}

  getAll(organisationId: string): Observable<Schedule[]> {
    return this.api.get(`/organisations/${organisationId}/schedules`);
  }

  getById(organisationId: string, scheduleId: number): Observable<ScheduleDetail> {
    return this.api.get(`/organisations/${organisationId}/schedules/${scheduleId}`).pipe(
      map((response: any) => ({
        id: scheduleId,
        sessions: response.sessions || [],
        resourceTypes: response.resourceTypes || []
      }))
    );
  }
}
